/* eslint-disable */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Collapse, Image } from "react-bootstrap";
import Badge from "react-bootstrap/Badge";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CopyIcon from "../../assets/img/copy.png";
import DeleteIcon from "../../assets/img/delete.png";
import EditIcon from "../../assets/img/edit.png";
import Restore from "../../assets/img/restore.png";
import MoreIcon from "../../assets/img/more_options.png";
import {
  SelectCampaignTab
} from "../../redux/actions/campaignAction";
import ButtonComponent from "../Common/ButtonComponent";
import { getStatusColor,getBadgeColor } from "../Shared/utils";
import TooltipF from "../TooltipF";
import { SelectOrderTab } from "../../redux/actions/orderAction";
import EyeIcon from "../../assets/img/EyeIcon.svg";
import { API_URL_FOR_CREATING_COMPAIGN_URL } from "../Shared/constant";


const CampaignItem = (props) => {
  const {
    user,
    DeleteCampaign,
    RestoreCampaign,
    CharityActivStatus,
    ElseMoreDetails,
    ViewMoreDetails,
    activeTableDetails,
    CharityActivStatus2,
    openPopup
  } = props;

  const dispatch = useDispatch();

  const [HoverText, setHoverText] = useState("Copy");
  const [showBorder, setShowBorder] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setHoverText("Copy");
    }, 2000);
  }, [HoverText]);

  const CopyPassword = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setHoverText("Copied");
        setShowBorder(true);
        setTimeout(() => {
          setShowBorder(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };


  return (
    <>
      <tr>
        <td style={{ width: "10px" }}>
          <button
            className={ activeTableDetails === user?.id ? "btn actionbtn active": "btn actionbtn"}
            onClick={() =>  activeTableDetails === user?.id ? ElseMoreDetails() : ViewMoreDetails(user?.id)}
            aria-controls="example-collapse-text"
            aria-expanded={activeTableDetails === user?.id ? true : false}>
            <Image src={MoreIcon} alt="more icon" />
          </button>
        </td>
        <td style={{width:"30%"}}>{user?.title ?  user?.title :"-"}</td>
        <td>{user?.start_date ?  moment(user?.start_date).format("LL") :"-"}</td>
        <td>{user?.end_date?  moment(user?.end_date).format("LL") :"-"}</td>
        <td className="text-capitalize">{user?.added_by ? user?.added_by : "-"}</td>
        <td className="space-nowrap text-nowrap"><Form className="switchbtn"><Badge bg={getBadgeColor(user?.status)} className={`text-capitalized`}>{user?.status==="pending" ? "draft" :user?.status}</Badge></Form></td>
        <td>
          <Form className="switchbtn">
            <Form.Check
              type="switch"
              id="custom-switch"
              checked={user?.web_appearance}
              onChange={(e) => {}}
              onClick={() => CharityActivStatus2(user)}
            />
            <Badge bg={user?.web_appearance ? "primary" : "danger"}>
              {user?.web_appearance ? "Yes" : "No"}
            </Badge>
          </Form>
        </td>
        <td>
          <Form className="switchbtn">
            <Form.Check
              type="switch"
              id="custom-switch"
              checked={user?.is_active}
              onChange={(e) => {}}
              onClick={() => CharityActivStatus(user)}
            />
            <Badge bg={user?.is_active ? "primary" : "danger"}>
              {user?.is_active ? "Yes" : "No"}
            </Badge>
          </Form>
        </td>
        <td className="space-nowrap text-nowrap">
          <div className="d-flex">
          {user?.status==="deleted" &&(
              <TooltipF title={"Restore"} placement={"top"}>
            <button
              className="btn actionbtn"
              onClick={() => RestoreCampaign(user)}
            >
              <Image src={Restore} alt="Restore icon" />
            </button>

              </TooltipF>
            )}
          <TooltipF title={"View"} placement={"top"}>
            <Button className="btn actionbtn view-button" onClick={() => openPopup(user)}> 
              <Image  src={EyeIcon} alt="delete icon" />                                  
            </Button>
          </TooltipF>
          <TooltipF title={"Edit"} placement={"top"}>
            <Link
              className="btn actionbtn"
              onClick={() => dispatch(SelectCampaignTab("edit-campaign"))}
              to={"/edit/campaign/" + user?.id}
            >
              <Image src={EditIcon} alt="edit icon" />
            </Link>
          </TooltipF>
            <TooltipF title={"Delete"} placement={"top"}>
              <button
                className="btn actionbtn"
                onClick={() => DeleteCampaign(user)}
              >
                <Image src={DeleteIcon} alt="delete icon" />
              </button>
            </TooltipF>

          </div>
        </td>
      </tr>
      <Collapse in={activeTableDetails === user?.id ? true : false}>
        <tr className="tablecollapsewraps" id={"tablecollpase" + user?.id}>
          <td colSpan="8">
            <table className="table">
              <tbody>
              <tr>
                  <th>Owner</th>
                  <td>{user?.owner?.first_name} ( {user?.owner?.email} )</td>
                </tr>
                <tr>
                  <th style={{ width: "20%" }}> Campaign Url </th>
                  {!user?.web_appearance ? (
                    <>
                      <td
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span id="copypasswordid">
                          {!user?.web_appearance === true ?  `${API_URL_FOR_CREATING_COMPAIGN_URL}campaigns/${user.slug}` :"-"}
                        </span>
                        <div
                          style={{ cursor: "pointer", marginLeft: "10px",}}
                          onClick={() => CopyPassword(`${API_URL_FOR_CREATING_COMPAIGN_URL}campaigns/${user.slug}`)}
                        >
                          <img
                            style={{
                              cursor: "pointer",
                              marginLeft: "10px",
                            }}
                            src={CopyIcon}
                            alt="copy icon"
                          />
                          <span>{HoverText}</span>
                        </div>
                        {/* </button> */}
                      </td>
                    </>
                  ) : (
                    <td>No Url Found </td>
                  )}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </Collapse>
    </>
  );
};

export default CampaignItem;
